module.exports = __webpack_public_path__ + "img/shopee_9thb_0009.4bd66609.png";